import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/sub-user',
    component: () => import('../layouts/SubUserLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: false },
    children: [
      {
        path: 'dashboard',
        name: 'SubUserDashboard',
        component: () => import('../views/sub-user/Dashboard.vue')
      },
      {
        path: 'expense/submit',
        name: 'SubmitExpense',
        component: () => import('../views/sub-user/SubmitExpense.vue')
      },
      {
        path: 'expense/list',
        name: 'ExpenseList',
        component: () => import('../views/sub-user/ExpenseList.vue')
      },
      {
        path: 'change-password',
        name: 'SubUserChangePassword',
        component: () => import('../views/sub-user/ChangePassword.vue')
      }
    ]
  },
  {
    path: '/admin',
    component: () => import('../layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/admin/Dashboard.vue')
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('../views/admin/UserManagement.vue')
      },
      {
        path: 'config',
        name: 'SystemConfig',
        component: () => import('../views/admin/SystemConfig.vue')
      },
      {
        path: 'expense/review',
        name: 'ExpenseReview',
        component: () => import('../views/admin/ExpenseReview.vue')
      },
      {
        path: 'expense/list',
        name: 'AdminExpenseList',
        component: () => import('../views/admin/ExpenseList.vue')
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('../views/admin/Statistics.vue')
      },
      {
        path: 'backup',
        name: 'Backup',
        component: () => import('../views/admin/Backup.vue')
      },
      {
        path: 'change-password',
        name: 'AdminChangePassword',
        component: () => import('../views/sub-user/ChangePassword.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.state.user.isAuthenticated
  const isAdmin = store.state.user.userInfo?.is_admin
  
  // 如果未登录但需要认证，尝试获取当前用户
  if (!isAuthenticated && to.meta.requiresAuth) {
    await store.dispatch('getCurrentUser')
  }
  
  const finalIsAuthenticated = store.state.user.isAuthenticated
  const finalIsAdmin = store.state.user.userInfo?.is_admin
  
  if (to.meta.requiresAuth && !finalIsAuthenticated) {
    next('/login')
  } else if (to.meta.requiresAdmin && !finalIsAdmin) {
    next('/sub-user/expense/list')
  } else if (to.path === '/login' && finalIsAuthenticated) {
    if (finalIsAdmin) {
      next('/admin/dashboard')
    } else {
      next('/sub-user/dashboard')
    }
  } else {
    next()
  }
})

export default router
